import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ConsumersState } from "../../models/mp-admin/consumers-state";

const initialState: ConsumersState = {
	loading: true,
	allRetrieved: false
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumers.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.consumers.getSuccess, (state, action) => {
		const existing = _.cloneDeep(_.get(state, "consumers", []));
		const consumers = _.unionBy(action.consumers, existing, "id");
		return { consumers, loading: action.loading, allRetrieved: action.allRetrieved };
	}),
	on(MpAdminActions.consumers.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function ConsumersReducer(
	state: ConsumersState | undefined,
	action: Action
): ConsumersState {
	return reducer(state, action);
}
